export default "__VITE_ASSET__2bc259d5__"